import { TimeMaterialRMAId } from './../../entities/tm/TimeMaterialRMAResponse';
import { TimeMaterialId } from './../../entities/tm/TimeMaterialResponse';
import { Endpoint } from '../endpoint';
import { CompactTimeMaterialRMAResponse, TimeMaterialRMAResponse } from '@business/entities/tm/TimeMaterialRMAResponse';

export function fetchItems(id: TimeMaterialId) {
  return Endpoint.get<CompactTimeMaterialRMAResponse[]>(`@gc/time-material/rma/${id}`);
}

export function fetchItem(id: TimeMaterialRMAId) {
  return Endpoint.get<TimeMaterialRMAResponse>(`@gc/time-material/rma/${id}`);
}

export function createItem(timeMaterialId: TimeMaterialId, data: Partial<CompactTimeMaterialRMAResponse>) {
  return Endpoint.post<TimeMaterialRMAResponse>(`@gc/time-material/rma/${timeMaterialId}`, { data });
}

export function updateItem(id: TimeMaterialRMAId, data: Partial<TimeMaterialRMAResponse>, isSend = false) {
  return Endpoint.patch<TimeMaterialRMAResponse>(`@gc/time-material/rma/${id}`, { data: { ...data, isSend } });
}

export function deleteItem(id: TimeMaterialRMAId) {
  return Endpoint.delete<void>(`@gc/time-material/rma/${id}`);
}
